import dayjs from 'dayjs';
import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';
import { CircularProgressbarWithChildren } from 'react-circular-progressbar';
import 'react-circular-progressbar/dist/styles.css';

import { ESCROW_EXPIRY_MINUTES } from '@constants';
import { useAppContext } from '@contexts';
import { handleRenderError } from '@utils/errorHandler';

const getRemainingSeconds = (targetTime: Date) =>
  dayjs(targetTime).diff(dayjs(), 'seconds');

export function EscrowTimer() {
  try {
    const { escrowExpiryTime, setEscrowExpiryTime, isPaymentCompleted } =
      useAppContext();
    const router = useRouter();
    const [seconds, setSeconds] = useState<number>(10);
    const [isActive, setIsActive] = useState<boolean>(true);

    if (!escrowExpiryTime) {
      return <></>;
    }

    useEffect(() => {
      let interval: NodeJS.Timer | undefined = undefined;
      if (isActive && seconds >= 1) {
        interval = setInterval(() => {
          setSeconds(() => getRemainingSeconds(escrowExpiryTime));
        }, 1000);
      } else if (isActive && seconds <= 0) {
        setIsActive(false);

        // Escrow exists to release inventory held by an abandoned cart. Once a
        // payment has been submitted the cart is not abandoned, so evicting the
        // buyer here would throw them out of a purchase they have paid for.
        if (isPaymentCompleted) {
          return;
        }

        setTimeout(() => {
          setEscrowExpiryTime(undefined);
          router.push(`/event/${router.query.eventId}`);
        }, 2000);
      } else if (!isActive) {
        clearInterval(interval);
      }
      return () => clearInterval(interval);
    }, [isActive, seconds, isPaymentCompleted]);

    useEffect(() => {
      if (escrowExpiryTime) {
        setSeconds(() => getRemainingSeconds(escrowExpiryTime));
      } else {
        setIsActive(false);
      }
    }, [escrowExpiryTime]);

    if (!isActive) {
      if (isPaymentCompleted) {
        return <></>;
      }

      return (
        <div
          style={{
            width: '30%',
            color: 'red',
            fontSize: '14px',
            textAlign: 'justify',
          }}
        >
          Your ticket is not reserved any longer. Please try again.
        </div>
      );
    }

    return (
      <div
        style={{
          color: seconds < 60 ? 'red' : 'auto',
          fontWeight: seconds < 60 ? 'bold' : 'normal',
        }}
      >
        <div style={{ width: 42, height: 42 }}>
          <CircularProgressbarWithChildren
            value={seconds}
            maxValue={ESCROW_EXPIRY_MINUTES * 60}
            counterClockwise
            styles={{
              path: { stroke: 'rgba(var(--primary-colour), 1)', width: '3px' },
              trail: {
                stroke: 'rgba(var(--background-colour), 1)',
                strokeLinecap: 'butt',
              },
            }}
          >
            <span
              style={{
                color: 'rgba(var(--primary-colour), 1)',
                fontSize: '13px',
                fontFamily: 'Basier Square',
              }}
            >{`${seconds}s`}</span>
          </CircularProgressbarWithChildren>
        </div>
      </div>
    );
  } catch (error) {
    return handleRenderError(error);
  }
}
